import { render, staticRenderFns } from "./MiniCardMetrics.vue?vue&type=template&id=3454b366&scoped=true"
import script from "./MiniCardMetrics.vue?vue&type=script&setup=true&lang=ts"
export * from "./MiniCardMetrics.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MiniCardMetrics.vue?vue&type=style&index=0&id=3454b366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454b366",
  null
  
)

export default component.exports